import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M8 .25a.75.75 0 0 1 .67.415l2.163 4.325 4.29.715a.75.75 0 0 1 .407 1.27l-3.56 3.56 1.408 4.228a.75.75 0 0 1-1.047.908L8 13.505l-4.331 2.166a.75.75 0 0 1-1.047-.908l1.409-4.227L.47 6.975a.75.75 0 0 1 .407-1.27l4.29-.715L7.329.665A.75.75 0 0 1 8 .25Zm0 2.427L6.338 6.002a.75.75 0 0 1-.548.404l-3.23.539 2.86 2.858c.2.2.27.498.18.767l-.983 2.95 3.048-1.524a.75.75 0 0 1 .67 0l3.048 1.523-.983-2.949a.75.75 0 0 1 .18-.767l2.86-2.858-3.23-.539a.75.75 0 0 1-.547-.404L8 2.677Z",
    "clip-rule": "evenodd"
  })
], -1), c = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" })
  ])
], -1), n = [
  o,
  c
];
function d(r, s) {
  return t(), l("svg", a, [...n]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
